<template>
    <div id="app">
        <vue-topprogress ref="topProgress" color="#da1831" :minimum="70" :speed="200" id="topProgress"></vue-topprogress>
        <div class="wrapper">
            <div class="wrapper-in">
                <!-- <salesModal></salesModal> -->
                <formLandModal v-if="isOpenFormLandModal"></formLandModal>
                <AppHeader v-if="setup != null"></AppHeader>
                <burgerMenu v-if="!isMobileChecker"></burgerMenu>
                <mobileSidebar v-if="isMobileChecker"></mobileSidebar>
                <main class="content" id="content-layout" v-if="setup != null">
                    <!-- <transition name="fade" mode="out-in"> -->
                        <router-view :key="$route.fullPath" v-cloak/>
                    <!-- </transition> -->
                </main>
                <!-- <formBazisClub></formBazisClub> -->
                <formConsult></formConsult>
                <AppFooterMobile v-if="isMobileChecker && routerName != 'contacts-sales'"></AppFooterMobile>
                <AppFooter></AppFooter>
                <transition name="fade" mode="out-in">
                    <div class="body-overlay" id="body-overlay" @click="closeMobileMenu(false)" v-cloak v-if="openFormConsult || overlayTrue || openSalesModal || isOpenFormLandModal" :class="{'openFormConsult': openFormConsult, 'openSalesModal' : openSalesModal, 'OpenFormLandModal' : isOpenFormLandModal}"></div>
                </transition>
            </div>
        </div>
    </div>
</template>

<script>
    // import hotBtns from '@/components/secret-btns/hot-btns.vue'
    // import firebase from 'firebase'
    import AppHeader from '@/components/header/header.vue'
    import AppFooter from '@/components/footer/footer.vue'
    import AppFooterMobile from '@/components/footer/footer-mobile.vue'
    import mobileSidebar from '@/components/mobile-sidebar/mobile-sidebar.vue'
    import burgerMenu from '@/components/burger-menu/burger-menu.vue'
    import formLandModal from '@/components/forms/form-land-modal.vue'

    // import salesModal from '@/components/partials/sales-modal.vue'
    import formConsult from '@/components/forms/form-consult.vue'
    import cookie from 'vue-cookie'
    // import formBazisClub from '@/components/forms/form-bazis-club.vue'
    // import formCovid from '@/components/forms/form-covid.vue'
    import {mapGetters} from 'vuex'
    export default {
        components: {
            AppHeader,
            AppFooter,
            AppFooterMobile,
            mobileSidebar,
            burgerMenu,
            formConsult,
            formLandModal,
            // formBazisClub,
            // formCovid,
            // salesModal,
            // hotBtns,
        },
        data () {
            return {
                routerName: this.$route.name,
                iSmobile: false,
                title: '',
                overlayTrue: false,
                // snowConf: {
                //     windPower : 0,  
                //     speed : .6,
                //     count : 100,
                //     size : 7,
                //     opacity : 1,
                //     images: ['https://sales.bazis.kz/cms/media/2023/12/snow-elem-01.svg',
                //             'https://sales.bazis.kz/cms/media/2023/12/snow-elem-02.svg',
                //             'https://sales.bazis.kz/cms/media/2023/12/snow-elem-03.svg',
                //             'https://sales.bazis.kz/cms/media/2023/12/snow-elem-04.svg',
                //             'https://sales.bazis.kz/cms/media/2023/12/snow-elem-05.svg',
                //             'https://sales.bazis.kz/cms/media/2023/12/snow-elem-06.svg',]
                // },
                // show: false      
            }
        },
        computed: mapGetters({
            setup: 'loadPageSetUp',
            openSendwich: 'loadOpenSendwich',
            openFormConsult: 'loadOpenFormConsult',
            openFormBazis: 'loadOpenFormBazis',
            openSalesModal: 'loadSalesModalAction',
            form: 'loadForms',
            isMobileChecker: 'loadIsMobileChecker',
            isOpenFormLandModal: 'loadIsOpenFormLandModal',
            // openGlobal: 'loadGlobalOpen',
            // openNotifMenu: 'loadOpenNotifyMenu',
            // addClassContent: 'loadADDclassToContent',
        }),
        methods: {
            // isMobileCheck() {
            //     var checkMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
            //     if (checkMobile) {
            //         this.isMobile = true
            //     }
            // },
            initSupportPage() {
                this.$router.push({name: 'support'});
            },
            closeMobileMenu(data) {
                this.overlayTrue = false;
                this.$store.commit('Open_Sendwich', false);
                this.$store.commit('Open_form_Consult', false);
                this.$store.commit('openSalesModalAction', false);
                document.getElementsByTagName('body')[0].classList.remove('overlay-open');
                document.getElementsByTagName('body')[0].classList.remove('overlay-open-sales-modal');
                if (this.isOpenFormLandModal) {
                    cookie.set('sales_form_land_modal_timer', true, { expires: this.form.form_drop_modal.minutes + 'm' });
                    this.$store.commit('Open_FormLandModal', false);
                }
            },
            checkActionsInURL() {
                var action = window.location
                var param = new URL(window.location.href).searchParams.get('urlAction');
                var cockie = this.$cookie.get('summerSalesModal');
                // && cockie == null
                if (param != null && param == 'summer_sales') {
                    this.$store.commit('openSalesModalAction', true);
                    document.getElementsByTagName('body')[0].classList.add('overlay-open-sales-modal');
                } else {
                    this.$store.commit('openSalesModalAction', false);
                    document.getElementsByTagName('body')[0].classList.remove('overlay-open-sales-modal');
                }
            },
            checkFormLandModal() {
                if (this.form != null) {
                    if (this.form != undefined && this.form.form_drop_modal.init == 'true') {
                        const seconds = parseInt(this.form.form_drop_modal.seconds) * 1000;
                        var timerCockie = cookie.get('sales_form_land_modal_timer');
                        setTimeout(() => {
                            if (timerCockie == null) {
                                this.$store.commit('Open_FormLandModal', true);
                            } 
                            // else { // если кука есть какие то действия при необходимости
                            //     console.log(timerCockie, 'COCKIE TIMER');
                            // }
                        }, seconds);
                    } 
                    // else {
                    //     // console.log('FORM LAND MODAL IS FFFFFALLLLLLSEEEEE ')
                    // }
                }
            },
            // MOBILE CHECKER
            isMobileCheck() {
                if (window.innerWidth < 767) {
                    this.iSmobile = true
                    this.$store.commit('setMobileCheckerState', true);
                    // this.$store.commit('setOffsetResponse', -60);
                }
            },
            handleResize() {
                if (window.innerWidth < 767) {
                    this.iSmobile = true
                    this.$store.commit('setMobileCheckerState', true);
                } else {
                    this.iSmobile = false
                    this.$store.commit('setMobileCheckerState', false);
                }
            },
            checkResize() {
                window.addEventListener('resize', this.handleResize)
                this.handleResize();
            },
            
        },
        beforeCreate() {
            if (localStorage.getItem('language') === null) {
                localStorage.setItem('language', '');
            }
            this.$store.dispatch('getCrmAuthToken_TESTCRM').then((response) => {
                // console.log(response, '- getting token');
                if (response == true) {
                    this.$store.dispatch('getFullSetUpProject');
                    this.$store.dispatch('getFlatsPageData');
                } else {
                    console.log('Ошибка получения токена - 509 ошибка')
                }
                
            });
            // this.$store.dispatch('getCrmAuthToken_TESTCRM');
            
            // this.$store.dispatch('getPageSetUp');
            // this.$store.dispatch('getBanerSystem');
        },
        created () {
        },
        mounted () {
            this.show = true;
            this.$refs.topProgress.start();
            this.isMobileCheck();
            this.checkResize();
            this.checkActionsInURL();
            this.$store.watch(
                (state) => state.forms,
                (newValue) => {
                    if (newValue != null) {
                        this.checkFormLandModal();
                    }
                }
            )
            // this.enableInterceptor();
        }
    }
</script>

<style>
.grecaptcha-badge {
    opacity: 0 !important;
    visibility: hidden;
}
</style>